<template>
    <div>
        
        <CCard class="p-4">
            <div class="row">
                <div class="col-md-6">
                    <h5>Fuel and Trip Allowance List ({{ total }})</h5> 
                    
                </div>
                 <div class="col-md-6 text-right">
                    <button 
                        class="btn btn-outline-primary"
                        @click="download"
                        :disabled="downloading"
                    >
                        <span v-if="downloading">
                            <i class="fa fa-spinner fa-spin"></i> Downloading...
                        </span>
                        <span v-else>
                            <i class="fa fa-download" 
                            v-if="config.getPermission('fuel_trip_management').download">
                            </i> 
                            Export Matrix
                        </span>
                    </button>
               </div>
                <!-- <div class="col-md-6 text-right">
                    <button class="btn btn-sm btn-primary" @click="download">
                        <i class="fa fa-download" v-if="config.getPermission('fuel_trip_management').download"></i> Download
                    </button>
                  
                </div> -->
                
            </div>

            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                    <label class="font-weight-bold">Upload Excel File</label>

                    <div class="custom-file-upload">
                        <input
                            type="file"
                            ref="fileInput"
                            class="d-none"
                            accept=".xlsx,.xls"
                            @change="onFileChange"
                        />

                        <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            :value="fileName"
                            placeholder="Choose Excel file..."
                            readonly
                        />

                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                type="button"
                                @click="$refs.fileInput.click()"
                                >
                                Browse
                            </button>
                            
                            <button
                                v-if="excelData.length && config.getPermission('fuel_trip_management').create"
                                :disabled="uploading"
                                class="btn btn-success ml-2"
                                @click="uploadExcelData"
                                type="button"
                                >
                                Upload
                            </button>
                            <button
                                class="btn btn-outline"
                                type="button"
                                @click="downloadTemplate"
                                >
                                Download template
                            </button>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="col-md-12 my-3" v-if="uploading">
                    <div class="progress mt-2 col-md-3 px-0">
                        <div class="progress-bar" :style="{ width: progress + '%' }">
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">

                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                            <label>Customer</label>
                            <input v-model="filter.customer"
                                type="text"
                                placeholder="Search Customer"
                                class="form-control">
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                            <label>Depot</label>
                            <input v-model="filter.depot"
                                type="text"
                                placeholder="Search Depot"
                                class="form-control">
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                            <label>Area</label>
                            <input v-model="filter.area"
                                type="text"
                                placeholder="Search Area"
                                class="form-control">
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                            <label>Truck Type</label>
                            <input v-model="filter.truck_type"
                                type="text"
                                placeholder="Search Truck Type"
                                class="form-control">
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                            <label>Commodity</label>
                            <input v-model="filter.commodity"
                                type="text"
                                placeholder="Search Commodity"
                                class="form-control">
                        </div>
                    </div>

                  
                    <div class="col-12 col-md-6 col-lg-2 d-flex align-items-end mb-3">
                        <div>
                            <button class="btn btn-outline-info btn-sm mr-2"
                                    @click="applyFilter">
                                <i class="fa fa-filter"></i> Apply Filter
                            </button>

                            <button class="btn btn-outline-info btn-sm"
                                    @click="clearFilter">
                                <i class="fa fa-trash"></i> Clear
                            </button>
                        </div>
                    </div>

                </div>
            <span v-if="showFilteredCount"><small><em><strong class="text-primary">{{ dataList.display.length }}</strong></em> record/s found.</small></span>
           
            <div class="mb-2" v-if="selectedRows.length">
                <button 
                    
                    class="btn btn-sm btn-danger"
                    @click="deleteMultiple"
                >
                    <i class="fa fa-trash"></i>
                    Multiple Delete ({{ selectedRows.length }})
                </button>
            </div>
           <div class="table-responsive-sm">
                <CDataTable 
                    :loading="is_loading"
                    :items="dataList.display"
                    :fields="fields"
                    hover
                    outlined
                    small
                    responsive
                    @pagination-change="paginationChange"
                    :itemsPerPageSelect="{values: [2,20,50,100]}"
                    :itemsPerPage="limit"
    >
            
                <template #select="{ item }">
                <td>
                    <input
                    type="checkbox"
                    :value="item.id"
                    v-model="selectedRows"
                    />
                </td>
                </template>
                <template #customer="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        {{ item.customer ? item.customer.customer_name : '-' }}
                    </td>
                </template>
                <template #depot="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        {{ item.depot ? item.depot.setting_name : '-' }}
                    </td>
                </template>
                <template #area="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        {{ item.area ? item.area.setting_name : '-' }}
                    </td>
                </template>
                <template #truck_type="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        {{ item.truck_type ? item.truck_type.setting_name : '-' }}
                    </td>
                </template>
                <template #commodity="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        {{ item.commodity ? item.commodity.setting_name : '-' }}
                    </td>
                </template>

                <template #trip_allowance="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        {{ item.trip_allowance | number_format('currency') }}
                    </td>
                </template>

                <template #fuel="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        {{ item.fuel }}
                    </td>
                </template>

                <template #id="{item}">
                    <td style="padding: 10px; text-transform:uppercase;">
                        <button class="btn btn-sm btn-danger" @click="deleteAllowance(item)">Delete</button>
                    </td>
                </template>

            </CDataTable> 
            <CPagination
                :active-page.sync="currentPage"
                :pages="Math.ceil(listTotal / limit)"
                :activePage="currentPage"
                @update:activePage="updatePage($event)"
            />
           </div>
        </CCard>

        
    </div>
</template>
<script>
    // import config from '../../config.js';
    import axios from '../axios';
    import config from '../config';
    import * as XLSX from "xlsx";
    import Swal from 'sweetalert2';
    function chunkArray(arr, size = 500) {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    }

    function removeExcelDuplicates(rows, keys = []) {
        const seen = new Set();

        return rows.filter((row, index) => {
            const parts = keys.map(k => {
            const val = row[k];
            return val === undefined || val === null
                ? "__EMPTY__"
                : val.toString().toLowerCase().trim();
            });

            const compositeKey = parts.join("|");

            // Optional: keep row if all keys are empty
            if (parts.every(v => v === "__EMPTY__")) {
            return true;
            }

            if (seen.has(compositeKey)) return false;

            seen.add(compositeKey);
            return true;
        });
        }

    export default {
        name : 'AreaFuelManagement',
        data() {
            
            return {
                downloading: false,
                selectedRows: [],
                config,
                is_loading: false,
                result: [],
                resultHolder: [],
                fields: [
                  
                      {
                        key: 'select',
                        label: '',
                        _style: { width: '40px' }
                    },

                     {
                        key: 'customer', 
                        label: 'Customer'
                    },
                     {
                        key: 'depot', 
                        label: 'Depot'
                    },
                    {
                        key: 'area', 
                        label: 'Area'
                    },
                    {
                        key: 'truck_type', 
                        label: 'Truck Type'
                    },
                    {
                        key: 'commodity', 
                        label: 'Commodity'
                    },
                    {
                        key: 'trip_allowance', 
                        label: 'Trip Allowance'
                    },
                    {
                        key: 'fuel', 
                        label: 'Fuel (L)'
                    },
                    {
                        key: 'id', 
                        label: 'Action'
                    },
                   
                  
                ],
                limit: 100,
                currentPage: 1,
                total: 0,
                excelHeaders: [],
                excelData: [],
                fileName: '',
                progress: 0,
                uploading: false,
                filter: {
                    area : '',
                    truck_type: '',
                    commodity: '',
                    customer:'',
                    depot:''
                },
                dataHolder: {},
                filterHolder:{
                    area : '',
                    truck_type: '',
                    commodity: '',
                    customer:'',
                    depot:''
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
           
            showFilteredCount() {
                const hasAnyValue = Object.values(this.filterHolder).some(value => value.trim() !== '');
                return hasAnyValue;
            },
            dataList() {

                // return this.dataHolder;
                
                let filters = this.filterHolder;
                let filtered = this.result.filter(item => {
                return  (!filters.area  || item.area?.setting_name.toLowerCase().includes(filters.area.toLowerCase())) &&
                        (!filters.depot  || item.depot?.setting_name.toLowerCase().includes(filters.depot.toLowerCase())) &&
                        (!filters.truck_type  || item.truck_type?.setting_name.toLowerCase().includes(filters.truck_type.toLowerCase())) &&
                        (!filters.customer  || item.customer?.customer_name.toLowerCase().includes(filters.customer.toLowerCase())) &&
                        (!filters.commodity || item.commodity?.setting_name.toLowerCase().includes(filters.commodity.toLowerCase()))
                })
                return {
                    display : filtered.slice((this.currentPage - 1) * this.limit, this.currentPage * this.limit),
                    raw : filtered
                }
            },
            listTotal() {
                return this.dataList.raw?.length ?? 0
            }
        },
        methods: {
            //multiple delete select
                    toggleSelectAll(event) {
                    const checked = event.target.checked;
                    const currentPageIds = this.dataList.display.map(item => item.id);

                    if (checked) {
                        // Add only current page IDs
                        this.selectedRows = [
                            ...new Set([...this.selectedRows, ...currentPageIds])
                        ];
                    } else {
                        // Remove current page IDs only
                        this.selectedRows = this.selectedRows.filter(
                            id => !currentPageIds.includes(id)
                        );
                    }
                },

          
             applyFilter() {
                
                this.currentPage = 1;
                this.filterHolder = {...this.filter}
            },
            clearFilter() {
                this.currentPage = 1;
                this.filterHolder = {
                    area : '',
                    truck_type: '',
                    commodity: '',
                    customer:'',
                    depot:''
                }

                this.filter = {...this.filterHolder}
            },

            //delete multiple records
            deleteMultiple() {
                if (!this.selectedRows.length) return;

                Swal.fire({
                    icon: 'warning',
                    title: `Delete ${this.selectedRows.length} selected record(s)?`,
                    text: 'You cannot revert this process.',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.is_loading = true;

                        try {
                            await axios.post(`${config.api_path}/fuel-trip-management/delete`, {
                                ids: this.selectedRows
                            });

                            Swal.fire('Deleted!', 'Selected records deleted.', 'success');

                            this.selectedRows = [];
                            this.selectAll = false;
                            this.getData();

                        } catch (err) {
                            console.error(err);
                            Swal.fire('Error', 'Failed to delete records.', 'error');
                        }

                        this.is_loading = false;
                    }
                });
            },
            deleteAllowance(item) {
                const vm = this;

                Swal.fire({
                    icon: 'warning',
                    title: `Delete fuel trip allowance?`,
                    text: 'You cannot revert this process.',
                    showCancelButton: true,
                    confirmButtonText: `Yes, delete`,
                }).then((result) => {

                    if (result.isConfirmed) {

                        vm.is_loading = true;

                        axios.post(`${config.api_path}/fuel-trip-management/delete`, {
                            id: item.id
                        })
                        .then(response => {

                            vm.getData();

                            // ✅ SUCCESS ALERT AFTER DELETE
                            Swal.fire({
                                icon: 'success',
                                title: 'Deleted!',
                                text: 'Fuel trip allowance has been deleted successfully.',
                                timer: 1500,
                                showConfirmButton: false
                            });

                        })
                        .catch(err => {

                            console.error(err);

                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: 'Something went wrong while deleting.'
                            });

                        })
                        .finally(() => {
                            vm.is_loading = false;
                        });

                    }
                });
            },
            // deleteAllowance(item) {
            //     const vm = this;
            //     Swal.fire({
            //         icon:'warning',
            //         title: `Delete fuel trip allowance?`,
            //         text: 'You cannot revert this process.', 
            //         showCancelButton: true,
            //         confirmButtonText: `Yes, delete`, 
            //         reverseButtons: false,
            //     }).then((result) => { 
            //         if (result.isConfirmed) {
            //             vm.is_loading = true;
            //             axios.post(`${config.api_path}/fuel-trip-management/delete`, {
            //                 id: item.id
            //             }).then(response => {
                            
            //                 vm.is_loading = false;
            //                 vm.getData()
            //             })
            //             .catch(err => {
            //                 console.error(err)
            //                 vm.is_loading = false;
            //             })
            //             .finally(fin => {
            //                 console.log(fin)
            //                 vm.is_loading = false;	
            //             })
                        
            //         }
            //     })  
                
            // },
            getData() {
                this.is_loading = true;
                axios.get(`${config.api_path}/fuel-trip-management/list`, {
                    params: {
                        page : this.currentPage,
                        limit : this.limit,
                    }
                }).then(response => {
                    const {data, total} = response.data;
                    this.result = data;
                    this.resultHolder = data;
                
                    this.total = total;

                    this.is_loading = false;
                    
                })
                .catch(err => {
                    console.error(err)
                    this.is_loading = false;
                })
                .finally(fin => {
                    console.log(fin)
                    this.is_loading = false;	
                })
            },
            paginationChange(ev){
                this.limit = ev;
                this.getData()
            },
            updatePage(ev){
                this.currentPage = ev;
                this.getData();
            }, 
            onFileChange(e) {
                const file = e.target.files[0];
                
                if (!file) return;
                this.fileName = file?.name;
                this.readExcel(file);
            },

            readExcel(file) {
                const vm = this;
                const reader = new FileReader();
                console.log('as')
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: "array" });

                    // Read first sheet
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];

                    // Convert to JSON (header → keys)
                    const json = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1,      // keep header row
                    defval: null    // keep empty cells
                    });

                    const headers = json[0];
                    const rows = json.slice(1);

                    // Map rows to objects using headers
                    const result = rows.map(row => {
                    let obj = {};
                    headers.forEach((h, i) => {
                        const val = isNaN(row[i]) ? row[i]?.toLowerCase() : row[i];
                        const head = h.toLowerCase() == 'diesel' ? 'fuel' : h.toLowerCase()
                        obj[head] = val ?? null;
                    });
                    return obj;
                    });

                    console.log("Headers:", headers);
                    console.log("Data:", result);

                    const cleanedRows = removeExcelDuplicates(
                        result,
                        ["customer","depot", "area", "truck type",'commodity']
                    );

                    console.log('CLEA',cleanedRows)

                    // Example: save to component state
                    this.excelHeaders = headers;
                    this.excelData = cleanedRows;
                };

                reader.readAsArrayBuffer(file);
            },

            async uploadExcelData() {
                const allowedHeader = ['customer',"depot",'area','fuel','truck type','allowance','commodity'];
                let headerFound = true;
                allowedHeader.forEach(al => {    
                    if(headerFound) {
                        headerFound = this.excelHeaders.find(h => h.toLowerCase() == al)
                    }
                })

                if(!headerFound) {
                    Swal.fire({
                        title: 'File upload failed!',
                        html : `<span>Incorrect file headers!<br><span>Allowed headers: <br> <em><strong>Area, Truck Type, Commodity, Diesel | Fuel, Allowance</strong></em></span></span>`,
                        icon: 'warning',
                        confirmButtonText : 'Close'
                    })
                    return;
                }

                const chunks = chunkArray(this.excelData, 500); // sweet spot
                const total = chunks.length;
                let error_holder = [];
                let _inserted = 0, _updated = 0;

                this.uploading = true;
                for (let i = 0; i < total; i++) {
                    await axios.post(`${config.api_path}/fuel-trip-management/upload`, {
                        data: chunks[i],
                        batch: i + 1,
                        total_batches: total
                    }).then(res => {
                        const {errors, inserted, updated} = res.data;
                        error_holder = [...errors, ...error_holder];
                        _inserted += parseInt(inserted);
                        _updated += parseInt(updated)
                    });

                    // Optional progress indicator
                    this.progress = Math.round(((i + 1) / total) * 100);
                }

                if(error_holder.length) {
                   	var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(error_holder);

                    XLSX.utils.book_append_sheet(wb, ws, "No Header");
                    // wb.SheetNames.push("Failed Trucker Rates");
                    wb.Sheets["Failed Fuel Trip Allowance"] = error_holder;
                    XLSX.writeFile(wb, "Failed Fuel Trip Allowance.xlsx", {type: 'xlsx'})
                }

                Swal.fire({
					title: 'Upload Complete!',
					html : `
					<ul class="list-group list-group-flush">
						<li class="list-group-item d-flex justify-content-between align-items-center">
							Inserted
							<span class="badge badge-success badge-pill">${_inserted}</span>
						</li>
						<li class="list-group-item d-flex justify-content-between align-items-center">
							Updated
							<span class="badge badge-warning badge-pill">${_updated}</span>
						</li>
						<li class="list-group-item d-flex justify-content-between align-items-center">
							Failed
							<span class="badge badge-danger badge-pill">${error_holder.length}</span>
						</li>
					</ul>
					`,
					icon: 'info',
					confirmButtonText : 'Close'
				})
                
                this.uploading = false;
                this.fileName = null;
                this.$refs.fileInput.value = null
                this.progress = 0;
                this.excelData = []
                this.getData()
                
            },
            async download() {
                this.downloading = true;

                try {
                    await new Promise(resolve => setTimeout(resolve, 300)); 
                    // small delay so spinner shows (optional but recommended)

                    const data = this.dataList.raw;
                    let result = [];

                    data.forEach(d => {
                        result.push({
                            'CUSTOMER': d.customer?.customer_name ?? '',
                            'DEPOT': d.depot?.setting_name ?? '',
                            'AREA': d.area?.setting_name ?? '',
                            'TRUCK TYPE': d.truck_type?.setting_name ?? '',
                            'COMMODITY': d.commodity?.setting_name ?? '',
                            'ALLOWANCE': d.trip_allowance,
                            'FUEL': d.fuel
                        });
                    });

                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(result);

                    XLSX.utils.book_append_sheet(wb, ws, "Fuel-Trip-Allowance");
                    XLSX.writeFile(wb, "Fuel-Trip-Allowance-Download.xlsx");

                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Download failed.', 'error');
                }

                this.downloading = false;
            },
            // download() {
            //     const data = this.dataList.raw;
            //     console.log(data)
            //     let result = [];
            //     data.forEach(d => {
            //         result.push({
            //             'CUSTOMER': d.customer?.customer_name ?? '',
            //             'DEPOT': d.depot?.setting_name ?? '',
            //             'AREA': d.area?.setting_name ?? '',
            //             'TRUCK TYPE': d.truck_type?.setting_name ?? '',
            //             'COMMODITY' : d.commodity?.setting_name ?? '',
            //             'ALLOWANCE' : d.trip_allowance,
            //             'FUEL' : d.fuel
            //         })
            //     })

            //     var wb = XLSX.utils.book_new();
            //     var ws = XLSX.utils.json_to_sheet(result);

            //     XLSX.utils.book_append_sheet(wb, ws, "No Header");
            //     // wb.SheetNames.push("Failed Trucker Rates");
            //     wb.Sheets["Fuel-Trip-Allowance-Download"] = result;
            //     XLSX.writeFile(wb, "Fuel-Trip-Allowance-Download.xlsx", {type: 'xlsx'})
            // },
            downloadTemplate() {
                const result = [{
                    'CUSTOMER': '',
                    'DEPOT': '',
                    'AREA': '',
                    'TRUCK TYPE': '',
                    'COMMODITY' : '',
                    'ALLOWANCE' : '',
                    'FUEL' : ''
                }]
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.json_to_sheet(result);

                XLSX.utils.book_append_sheet(wb, ws, "No Header");
                // wb.SheetNames.push("Failed Trucker Rates");
                wb.Sheets["Fuel-Trip-Allowance-Template"] = result;
                XLSX.writeFile(wb, "Fuel-Trip-Allowance-Template.xlsx", {type: 'xlsx'})
            }
            
        },

        
    }
</script>